import { Co2Section } from '@/domain/impact-co2/entities/question.entity';
import { translate } from '@/ui/i18n';
import { AccommodationForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/AccommodationForm';
import { QuizFormSeparator } from '@/ui/pages/app/components/quiz-panel/co2/components/QuizFormSeparator';
import { ImpactQuestionContext } from '@/ui/pages/app/components/quiz-panel/ImpactQuestionContext';
import { GenericExternalPageFestival } from '@/ui/pages/external/festival/components/GenericExternalPageFestival';
import { useExternalSubmitAnswer } from '@/ui/pages/external/hooks/useExternalSubmitAnswer';

export function TeamAccommodation() {
  return (
    <GenericExternalPageFestival>
      <Form />
    </GenericExternalPageFestival>
  );
}

function Form({ readOnly = false }: { readOnly?: boolean }) {
  const { onDelete, onSubmit, onEdit } = useExternalSubmitAnswer();

  const sector = 'TEAM';

  const panelOpen = !readOnly;
  return (
    <ImpactQuestionContext.Provider
      value={{ panelOpen: panelOpen, hideCompleted: false }}
    >
      <QuizFormSeparator
        label={translate(`Co2.Sections.${Co2Section.ACCOMMODATION}`)}
      />
      <AccommodationForm
        sector={sector}
        onDelete={onDelete}
        onSubmit={onSubmit}
        onEdit={onEdit}
        isExternal
      />
    </ImpactQuestionContext.Provider>
  );
}
